
    import Vue from "vue";
    import {Component, Prop} from "vue-property-decorator";
    import {VueInject} from "@/VueIntegration/VueInjectable";
    import {ClosedCaptionsService} from "@/ClosedCaptionsService";
    import {CaptionPosition} from "@/Core/SlideshowData";

    @Component({})
    export default class ClosedCaptions extends Vue {
        @Prop({required: true}) slideId: string;

        @VueInject("ClosedCaptionsService") closedCaptionsService: ClosedCaptionsService;

        created() {
            this.closedCaptionsService.onCaptionUpdate(caption => {
                if (caption == null) {
                    this.captionText = "";
                }
                else {
                    this.captionText = caption.text;
                    this.isCaptionTop = caption.position === CaptionPosition.Top;
                }

            });
        }

        captionText = "";
        isCaptionTop = false;
    }
